var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.79961C18 4.13689 17.4627 3.59961 16.8 3.59961H1.2C0.537282 3.59961 0 4.13689 0 4.79961C0 5.46233 0.537282 5.99961 1.2 5.99961H16.8C17.4627 5.99961 18 5.46228 18 4.79961ZM1.2 10.7996H22.8C23.4627 10.7996 24 11.3369 24 11.9996C24 12.6623 23.4627 13.1996 22.8 13.1996H1.2C0.537282 13.1996 0 12.6623 0 11.9996C0 11.3369 0.537282 10.7996 1.2 10.7996ZM1.2 17.9996H12C12.6627 17.9996 13.2 18.5369 13.2 19.1996C13.2 19.8623 12.6627 20.3996 12 20.3996H1.2C0.537282 20.3996 0 19.8623 0 19.1996C0 18.5369 0.537282 17.9996 1.2 17.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3ea2c5f5421b33b6df0b8e5553ea2907.svg";
export { ForwardRef as ReactComponent };